'use client'

import { LoaderCircle } from 'lucide-react'
import {
	AlertDialogAction,
	AlertDialogCancel,
	AlertDialogContent,
	AlertDialogDescription,
	AlertDialogFooter,
	AlertDialogHeader,
	type AlertDialogProps,
	AlertDialogTitle,
	AlertDialogTrigger,
	AlertDialog as UIAlertDialog,
} from './ui/alert-dialog'

interface Props extends Omit<AlertDialogProps, 'children'> {
	children?: React.ReactNode
	triggerAsChild?: boolean
	title: React.ReactNode
	loading?: boolean
	description?: React.ReactNode
	confirm?: React.ReactNode
	cancel?: string
	success?: React.ReactNode
	onConfirm?: () => void
	onCancel?: () => void
}

export const AlertDialog: React.FC<Props> = ({
	children,
	triggerAsChild = true,
	title,
	loading,
	description,
	confirm = 'Ok',
	cancel = 'Avbryt',
	success,
	onConfirm,
	onCancel,
	...rest
}) => {
	return (
		<UIAlertDialog {...rest}>
			{children && (
				<AlertDialogTrigger asChild={triggerAsChild}>
					{children}
				</AlertDialogTrigger>
			)}
			<AlertDialogContent className="p-0">
				<AlertDialogHeader className="border-b border-gray-300 py-4 px-6">
					<AlertDialogTitle>{title}</AlertDialogTitle>
				</AlertDialogHeader>
				{description && (
					<AlertDialogDescription className="px-6">
						{description}
					</AlertDialogDescription>
				)}
				<AlertDialogFooter className="py-4 px-6">
					{success ? (
						success
					) : (
						<>
							<AlertDialogCancel disabled={loading} onClick={onCancel}>
								{cancel}
							</AlertDialogCancel>
							<AlertDialogAction disabled={loading} onClick={onConfirm}>
								{loading && (
									<LoaderCircle className="mr-2 h-4 w-4 animate-spin" />
								)}
								{confirm}
							</AlertDialogAction>
						</>
					)}
				</AlertDialogFooter>
			</AlertDialogContent>
		</UIAlertDialog>
	)
}
